export type MAX_LENGTH_CONSTRAINT = {
  max: number
}

export type MAX_LENGTH<T = any> = (
  value: string,
  constraints: T,
) => string | undefined

export const mustBeMaxLength: MAX_LENGTH = (value, { max }) =>
  max >= value.length ? undefined : `MAX_LENGTH`
